import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import NavbarLinks from './NavbarLinks.json';
import logo from '../assets/logo2-color.svg';

const Navbar = (path) => {
    const { page } = path;
    const directory = page.split('/')[1] ? page.split('/')[1] : '';

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
        const isScrolled = window.scrollY > window.innerHeight;
        setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up event listener on unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    
    let navClasses = page + " " + directory;
    navClasses += scrolled ? ' scrolled' : '';

    function toggleMobileMenu() {
        const nav = document.querySelector("nav");
        nav.classList.toggle("mobile-menu-open");
    }

    return (
        <motion.div>
            <nav className={navClasses}>
                <div className='logo'>
                    <Link className='nav-link' to='/'>
                        <img src={logo} style={{ width: '50px' }} alt="Zoty United logo" />
                    </Link>
                </div>
                <div className='nav-links'>
                    {NavbarLinks.map((link, key) => {
                        const isCurrentPage = page === link.location;
                        return isCurrentPage ? (
                            <div className='nav-link disabled' key={key}>
                                <div className='nav-item'>
                                    {link.name} <i className='fas fa-location-arrow'></i>
                                </div>
                            </div>
                        ) : (
                            link.external ? (
                                <a href={link.location} className="nav-link" target="_blank" rel="nooopener noreferrer" key={key}>
                                    <div className="nav-item">
                                        {link.name}
                                    </div>
                                </a>
                            ) : (
                                <Link className='nav-link' to={link.location} key={key} onClick={toggleMobileMenu}>
                                    <div className='nav-item'>
                                        {link.name}
                                    </div>
                                </Link>
                            )
                        );
                    })}
                </div>
                <div className='mobile-menu-toggle' onClick={toggleMobileMenu}></div>
            </nav>
        </motion.div>
    );
};

export default Navbar;